import { Game } from './game/game'
import { initPWA } from './ui/pwa'

function boot(): void {
  const app = document.getElementById('app')
  if (!app) throw new Error('#app container missing')

  initPWA() // installable PWA + service worker (lets phone players add it to the home screen, fullscreen)

  // eslint-disable-next-line @typescript-eslint/no-new
  new Game(app)

  // remove the loading splash once the first frame is up
  const loading = document.getElementById('loading')
  if (loading) {
    requestAnimationFrame(() => {
      loading.style.transition = 'opacity .4s'
      loading.style.opacity = '0'
      setTimeout(() => loading.remove(), 420)
    })
  }
}

boot()
